import React, { useContext, Component } from 'react';
import { Link, navigate } from '@reach/router';

import { getTime, covertToDaysJS } from './firebase';
import UserContext from './providers/UserProvider';
import { BlobServiceClient } from '@azure/storage-blob';
import { getAzureStorageInfo } from './services/SasGeneratorService';

import {
    Layout,
    Breadcrumb,
    List,
    Table,
    Spin,
    Upload,
    Button,
    message,
    Space,
    Typography,
    Tooltip,
    Row,
    Col,
    Progress,
    Avatar,
    Popover,
    Divider,
    Popconfirm,
    Dropdown,
    Form,
    Input
} from 'antd';

import {
    FolderOutlined,
    FileTextOutlined,
    ProjectTwoTone,
    UnlockTwoTone,
    DownloadOutlined,
    CheckOutlined
} from '@ant-design/icons';
const { Header, Content, Footer } = Layout;
const { Title, Text } = Typography;

import { isDev } from './GlobalParams';
import ConfigModal from './ConfigModal';
import { dataService } from './dataService';
import { fromPairs } from 'lodash';

type FileItem = {
    createdBy: String,
    createdOn: firebase.firestore.Timestamp,
    downloadURL: String,
    lastAccessedBy: String,
    lastAccessedOn: firebase.firestore.Timestamp,
    name: String,
    size: Number,
    type: String,
    uid: String,
    path: String
};

type State = {
    itemList: Array<firebase.storage.Reference>,
    breadcrumb: Array<String>,
    isLoading: Boolean,
    selectedRowKeys: Array<firebase.storage.Reference>,
    selectedFile: FileItem
};

export default class Landing extends Component {
    state: State;

    state = {
        isLoading: false,
        progressMsg: '',
        showCreateFolder: false,

        breadcrumb: [],
        selectedRowKeys: [],
        selectedRows: [],
        itemList: [],
        pagination: {
            current: 0,
            pageSize: 50
        }
    };

    storageRef: firebase.storage.Reference = null;
    currentPath: String;

    AppInstance = null;
    firestoreRef = null;
    formRef = React.createRef();

    render() {
        const { selectedRowKeys } = this.state;

        const rowSelection = {
            type: 'radio',
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({ selectedRowKeys, selectedRows });
            },
            getCheckboxProps: (record) => ({
                name: record.name
            })
        };
        const hasSelected = selectedRowKeys.length > 0;

        const breadcrumbItems = this.state.breadcrumb.map((link) => (
            <Breadcrumb.Item key={link.key}>
                <a onClick={() => this.loadData(link.value)}>{link.key}</a>
            </Breadcrumb.Item>
        ));

        const uploadToAzureBlobStorage = async (
            file: File,
            fileFullPath: string
        ) => {
            let AppInstance = this;
            const azureStorageInfo = await getAzureStorageInfo();
            const blobServiceClient = new BlobServiceClient(
                `https://${azureStorageInfo.azureStorageName}.blob.core.windows.net/?${azureStorageInfo.sasToken}`
            );
            const containerClient = blobServiceClient.getContainerClient(
                'usermanuals'
            );
            const blockBlobClient = containerClient.getBlockBlobClient(
                fileFullPath
            );
            let uploadItem = await blockBlobClient.uploadBrowserData(file, {
                onProgress: (progress) => {
                    var bytesTrans = (
                        progress.loadedBytes /
                        (1024 * 1024)
                    ).toFixed(2);
                    var totalBytes = (file.size / (1024 * 1024)).toFixed(2);
                    var progress = ((bytesTrans / totalBytes) * 100).toFixed();
                    var progressMsg = `${progress}% uploaded (${bytesTrans} MB of ${totalBytes} MB)`;
                    AppInstance.setState({ progressMsg });
                }
            });
            return blockBlobClient.url;
        };

        const deleteFromAzureBlobStorage = async (fileFullPath: string) => {
            let AppInstance = this;
            const account = 'sparedoxweb';
            const azureStorageInfo = await getAzureStorageInfo();
            const blobServiceClient = new BlobServiceClient(
                `https://${azureStorageInfo.azureStorageName}.blob.core.windows.net/?${azureStorageInfo.sasToken}`
            );
            const containerClient = blobServiceClient.getContainerClient(
                'usermanuals'
            );

            let deleteResponse = await containerClient.deleteBlob(
                fileFullPath,
                { deleteSnapshots: 'include' }
            );
        };

        const onDeleteConfirm = async () => {
            let AppInstance = this;
            AppInstance.setState({
                isLoading: true
            });
            this.state.selectedRows.forEach(async (item) => {
                try {
                    const fileFullPath = AppInstance.getFullPath(item.name);
                    await deleteFromAzureBlobStorage(fileFullPath);
                    const fileDBRef = dataService.firestore
                        .collection('files')
                        .doc(item.key);
                    await fileDBRef.delete();
                    await dataService.firestore
                        .collection('docMarkers')
                        .where('fileId', '==', item.id)
                        .delete();

                    await AppInstance.loadData(AppInstance.currentPath);

                    message.success(item.name + ' Deleted');
                    AppInstance.setState({
                        isLoading: false
                    });
                } catch (error) {
                    message.error(error.message);
                    console.error(error);
                    AppInstance.setState({
                        isLoading: false
                    });
                }
            });
        };
        const beforeUpload = async (file: File, value) => {
            const fileFullPath = this.getFullPath(file.name);
            let docName = fileFullPath.replace(new RegExp('/', 'g'), '|');
            const fileRef = await this.firestoreRef.doc(`files/${docName}`);
            const snapshot = await fileRef.get();
            if (snapshot.exists) {
                message.error('File already exists.');
            } else {
                let AppInstance = this;
                AppInstance.setState({ isLoading: true });

                let downloadURL = await uploadToAzureBlobStorage(
                    file,
                    fileFullPath
                );
                downloadURL = downloadURL.split('?')[0];
                var newfileRef = AppInstance.firestoreRef
                    .collection('files')
                    .doc(docName);
                await newfileRef.set({
                    key: docName,
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    createdOn: getTime(),
                    createdBy: value.user.uid,
                    downloadURL: downloadURL,
                    path: AppInstance.currentPath,
                    isFile: true,
                    lastAccessedOn: getTime(),
                    lastAccessedBy: value.user.uid
                });
                AppInstance.setState({ isLoading: false, progressMsg: '' });
                AppInstance.loadData(AppInstance.currentPath);
                message.success('File Uploaded');
            }
        };
        return (
            <UserContext.Consumer>
                {(value) => (
                    <Layout>
                        <Header
                            style={{
                                position: 'fixed',
                                zIndex: 1,
                                width: '100%'
                            }}
                        >
                            <Row justify="end">
                                <Col span={8}>
                                    <Tooltip
                                        title="SpareDox"
                                        placement="right"
                                        mouseEnterDelay="0"
                                        mouseLeaveDelay="1"
                                    >
                                        <Button
                                            size="large"
                                            type="default"
                                            shape="circle"
                                            icon={<ProjectTwoTone />}
                                        />
                                    </Tooltip>
                                </Col>
                                <Col
                                    span={12}
                                    offset={4}
                                    style={{
                                        paddingLeft: '25%',
                                        textAlign: 'end'
                                    }}
                                >
                                    <Popover
                                        placement="bottomRight"
                                        title={
                                            <Space
                                                direction="vertical"
                                                align="center"
                                                style={{ width: '100%' }}
                                            >
                                                <Avatar
                                                    size={64}
                                                    src={value.user.photoURL}
                                                />
                                                <Text level={4}>
                                                    {value.user.displayName}
                                                </Text>
                                                <Text>{value.user.email}</Text>
                                            </Space>
                                        }
                                        content={
                                            <div
                                                style={{ textAlign: 'center' }}
                                            >
                                                {value.user.admin ? (
                                                    <Button
                                                        type="default"
                                                        onClick={() =>
                                                            navigate('admin')
                                                        }
                                                        block
                                                    >
                                                        <UnlockTwoTone /> Admin
                                                    </Button>
                                                ) : null}
                                                <Divider />
                                                <Button
                                                    type="default"
                                                    onClick={async () => {
                                                        this.props.signOut();
                                                    }}
                                                >
                                                    Sign out
                                                </Button>
                                            </div>
                                        }
                                        trigger="click"
                                    >
                                        <Avatar
                                            style={{ cursor: 'pointer' }}
                                            src={value.user.photoURL}
                                        />
                                    </Popover>
                                </Col>
                            </Row>
                        </Header>
                        <Content style={{ padding: '0 50px', marginTop: 64 }}>
                            <Breadcrumb style={{ margin: '16px 0' }}>
                                {breadcrumbItems}
                            </Breadcrumb>
                            <div className="site-layout-content">
                                <Spin
                                    spinning={this.state.isLoading}
                                    tip={this.state.progressMsg}
                                >
                                    <div style={{ marginBottom: 16 }}>
                                        <Row>
                                            <Col span={12}>
                                                <Space>
                                                    <Upload
                                                        showUploadList={false}
                                                        accept={'.pdf'}
                                                        beforeUpload={(
                                                            file
                                                        ) => {
                                                            beforeUpload(
                                                                file,
                                                                value
                                                            );
                                                            return false;
                                                        }}
                                                    >
                                                        <Button>Upload</Button>
                                                    </Upload>

                                                    <Button
                                                        onClick={() => {
                                                            this.loadData(
                                                                this.currentPath
                                                            );
                                                        }}
                                                    >
                                                        Refresh
                                                    </Button>

                                                    {hasSelected &&
                                                        this.state
                                                            .selectedRows[0]
                                                            .isFile && (
                                                            <React.Fragment>
                                                                {value.user
                                                                    .admin && (
                                                                    <Popconfirm
                                                                        title="Are you sure delete this file?"
                                                                        onConfirm={
                                                                            onDeleteConfirm
                                                                        }
                                                                        okText="Yes"
                                                                        cancelText="No"
                                                                    >
                                                                        <Button
                                                                            danger
                                                                        >
                                                                            Delete
                                                                        </Button>
                                                                    </Popconfirm>
                                                                )}

                                                                <ConfigModal
                                                                    filePath={
                                                                        (this
                                                                            .currentPath
                                                                            ? this
                                                                                  .currentPath +
                                                                              '/'
                                                                            : '') +
                                                                        this
                                                                            .state
                                                                            .selectedRows[0]
                                                                            .name
                                                                    }
                                                                    fileId={
                                                                        this
                                                                            .state
                                                                            .selectedRows[0]
                                                                            .id
                                                                    }
                                                                    setIsLoading={(
                                                                        val
                                                                    ) =>
                                                                        this.setState(
                                                                            {
                                                                                isLoading: val
                                                                            }
                                                                        )
                                                                    }
                                                                />

                                                                <Button
                                                                    target="_blank"
                                                                    download={
                                                                        this
                                                                            .state
                                                                            .selectedRows[0]
                                                                            .name
                                                                    }
                                                                    href={
                                                                        this
                                                                            .state
                                                                            .selectedRows[0]
                                                                            .downloadURL
                                                                    }
                                                                >
                                                                    Download
                                                                </Button>
                                                            </React.Fragment>
                                                        )}
                                                </Space>
                                            </Col>
                                            <Col span={12} align="end">
                                                <Popover
                                                    visible={
                                                        this.state
                                                            .showCreateFolder
                                                    }
                                                    onVisibleChange={(
                                                        visible
                                                    ) => {
                                                        this.setState({
                                                            showCreateFolder: visible
                                                        });
                                                    }}
                                                    content={
                                                        <Form
                                                            ref={this.formRef}
                                                            name="createfolder_state"
                                                            layout="inline"
                                                            onFinish={async (
                                                                values
                                                            ) => {
                                                                let fileFullPath = this.getFullPath(
                                                                    values.newFolderName
                                                                );
                                                                let docFolderName = fileFullPath.replace(
                                                                    new RegExp(
                                                                        '/',
                                                                        'g'
                                                                    ),
                                                                    '|'
                                                                );
                                                                var newfolderRef = this.firestoreRef
                                                                    .collection(
                                                                        'files'
                                                                    )
                                                                    .doc(
                                                                        docFolderName
                                                                    );
                                                                await newfolderRef.set(
                                                                    {
                                                                        key: docFolderName,
                                                                        name:
                                                                            values.newFolderName,
                                                                        type:
                                                                            'folder',
                                                                        createdOn: getTime(),
                                                                        createdBy:
                                                                            value
                                                                                .user
                                                                                .uid,
                                                                        path: this
                                                                            .currentPath,
                                                                        isFile: false,
                                                                        lastAccessedOn: getTime(),
                                                                        lastAccessedBy:
                                                                            value
                                                                                .user
                                                                                .uid
                                                                    }
                                                                );
                                                                message.success(
                                                                    values.newFolderName +
                                                                        ' created.'
                                                                );
                                                                this.setState({
                                                                    showCreateFolder: !this
                                                                        .state
                                                                        .showCreateFolder
                                                                });
                                                                this.loadData(
                                                                    this
                                                                        .currentPath
                                                                );
                                                                this.setState({
                                                                    showCreateFolder: false
                                                                });
                                                                this.formRef.current.resetFields();
                                                            }}
                                                        >
                                                            <Form.Item
                                                                name="newFolderName"
                                                                label="Folder name"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message:
                                                                            'Folder name is required!'
                                                                    }
                                                                ]}
                                                            >
                                                                <Input
                                                                    allowClear
                                                                    addonAfter={
                                                                        <Button
                                                                            htmlType="submit"
                                                                            icon={
                                                                                <CheckOutlined />
                                                                            }
                                                                            size="small"
                                                                        />
                                                                    }
                                                                />
                                                            </Form.Item>
                                                        </Form>
                                                    }
                                                    placement="left"
                                                    trigger="click"
                                                >
                                                    <Button>
                                                        Create Folder
                                                    </Button>
                                                </Popover>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Table
                                        rowSelection={{
                                            ...rowSelection
                                        }}
                                        columns={[
                                            {
                                                title: 'Name',
                                                dataIndex: 'name',
                                                render: (
                                                    text,
                                                    item: firebase.storage.Reference
                                                ) => (
                                                    <a
                                                        onClick={async () => {
                                                            if (item.isFile) {
                                                                this.setState({
                                                                    isLoading: true
                                                                });
                                                                location.href =
                                                                    '/?' +
                                                                    item.key;
                                                            } else {
                                                                this.loadData(
                                                                    this.getFullPath(
                                                                        item.name
                                                                    )
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        {item.isFile ? (
                                                            <FileTextOutlined />
                                                        ) : (
                                                            <FolderOutlined />
                                                        )}{' '}
                                                        {item.name}
                                                    </a>
                                                )
                                            },
                                            {
                                                title: 'Size',
                                                dataIndex: 'size',
                                                render: (
                                                    text,
                                                    item: firebase.storage.Reference
                                                ) =>
                                                    item.isFile &&
                                                    `${(
                                                        text /
                                                        (1024 * 1024)
                                                    ).toFixed(2)} MB`
                                            },
                                            {
                                                title: 'Last accessed',
                                                dataIndex: 'lastAccessedOn',
                                                render: (
                                                    text,
                                                    item: firebase.storage.Reference
                                                ) =>
                                                    item.isFile && (
                                                        <span>
                                                            {covertToDaysJS(
                                                                text
                                                            )}
                                                        </span>
                                                    )
                                            }
                                        ]}
                                        dataSource={this.state.itemList}
                                        pagination={false}
                                    />
                                </Spin>
                            </div>
                        </Content>
                        <Footer style={{ textAlign: 'center' }}>
                            SpareDox
                        </Footer>
                    </Layout>
                )}
            </UserContext.Consumer>
        );
    }

    getFullPath(fileName: String) {
        let temp = [];
        if (this.currentPath) temp.push(this.currentPath);
        temp.push(fileName);
        return temp.join('/');
    }

    loadData = async (path: String) => {
        this.setState({ isLoading: true });
        let db = dataService.firestore;
        this.setState({ selectedRowKeys: [], selectedRows: [] });

        let breadcrumbList = [{ key: 'Home', value: '' }];
        if (path) {
            path.split('/').forEach((element) => {
                let itemPath = path.substring(
                    0,
                    path.indexOf(element) + element.length
                );
                breadcrumbList.push({ key: element, value: itemPath });
            });
        }

        this.currentPath = path || '';
        let itemList: Array<firebase.storage.Reference> = [];

        let first = db
            .collection('files')
            .where('path', '==', this.currentPath)
            .orderBy('name')
            .startAt(this.state.pagination.current)
            .limit(this.state.pagination.pageSize);

        let result = await first.get();
        result.forEach((r) => {
            r = r.data();
            itemList.push(r);
        });

        this.setState({
            itemList: itemList,
            breadcrumb: breadcrumbList,
            isLoading: false
        });
    };

    componentDidMount = async () => {
        this.firestoreRef = dataService.firestore;
        this.loadData();
    };
}



// WEBPACK FOOTER //
// ./demo/src/Landing.js